module.exports = __webpack_public_path__ + "static/media/slide3Active.4251e1c6.png";